// Root component
import './App.css';
import Header from './components/Header';
import ListOfCities from './components/ListOfCities';


function App() {
  return (
    <main className='background'>
      <Header />
      <ListOfCities />
      
    </main>
  );
}

export default App;
